function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { configureStore } from '@reduxjs/toolkit';
import { tapi } from './api';
import { campaignAlertsSlice } from './campaignAlerts';
import { campaignsSlice } from './campaigns';
import { popupSlice } from './popup';
export var getStore = function(preloadedState) {
    var _obj;
    return configureStore({
        reducer: (_obj = {}, _define_property(_obj, tapi.reducerPath, tapi.reducer), _define_property(_obj, "campaigns", campaignsSlice.reducer), _define_property(_obj, "campaignAlerts", campaignAlertsSlice.reducer), _define_property(_obj, "popup", popupSlice.reducer), _obj),
        middleware: function(getDefaultMiddleware) {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [
                        'popup/setPopupProps',
                        'popup/updatePopupProps'
                    ],
                    ignoredPaths: [
                        'popup.componentProps.onConfirm',
                        'popup.componentProps.onCancel'
                    ]
                }
            }).concat(tapi.middleware);
        },
        preloadedState: preloadedState
    });
};
export var store = getStore({});
